import { Card, CardContent, Skeleton, Stack } from "@mui/material";

const ChartSkeletonHorizontalBar = ({ bars = 6, height = 200 }) => (
  <Card
    sx={{
      backgroundColor: "#fff",
      borderRadius: 3,
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
      border: "1px solid #e5e7eb",
    }}
  >
    <CardContent>
      <Skeleton variant="text" width="30%" height={30} sx={{ mb: 2 }} />
      <Stack spacing={1}>
        {Array.from({ length: bars }).map((_, i) => (
          <Stack direction="row" alignItems="center" spacing={1} key={i}>
            {/* <Skeleton variant="text" width={80} height={20} /> */}
            <Skeleton
              variant="rectangular"
              height={40}
              width={`${Math.floor(Math.random() * 60 + 40)}%`}
              sx={{ borderRadius: 2 }}
            />
          </Stack>
        ))}
      </Stack>
    </CardContent>
  </Card>
);

export default ChartSkeletonHorizontalBar;
